export enum TicketCategory {
  SWA_REPORTING_BUG = 'SWA_REPORTING_BUG',
  SWA_FEATURE_REQUEST = 'SWA_FEATURE_REQUEST',
  SST_ISSUE = 'SST_ISSUE',
  THR_ISSUE = 'THR_ISSUE',
  D2D_ISSUE = 'D2D_ISSUE',
  GENERAL_TECH_ISSUE = 'GENERAL_TECH_ISSUE',
  GENERAL_SUPPORT_ISSUE = 'GENERAL_SUPPORT_ISSUE',
  TEAM_ASSIGNMENT = 'TEAM_ASSIGNMENT',
  MISSING_PROJECT_DATA = 'MISSING_PROJECT_DATA'
}

export enum TicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  CLOSED = 'closed'
}

export enum TicketPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export interface Ticket {
  id: string;
  title: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  internal_priority?: TicketPriority;
  category: TicketCategory;
  loom_link?: string;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  assigned_to: string | null;
  project_id?: string;
  due_date?: string;
  user_profiles?: {
    id: string;
    name: string;
    email: string;
  };
  assigned_user?: {
    id: string;
    name: string;
    email: string;
  };
  unread_comments_count?: number;
}

export interface TicketComment {
  id: string;
  ticket_id: string;
  content: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  is_internal: boolean;
  mentioned_user_ids?: string[];
  user_profiles?: {
    id: string;
    name: string;
    email: string;
  };
  read_status?: {
    is_read: boolean;
    read_at: string | null;
  };
}

export interface TicketAttachment {
  id: string;
  ticket_id: string;
  file_name: string;
  file_path: string;
  file_type: string;
  file_size: number;
  uploaded_at: string;
  uploaded_by: string | null;
}

export interface TicketHistory {
  id: string;
  ticket_id: string;
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  changed_at: string;
  changed_by: string | null;
}

export interface CreateTicketInput {
  title: string;
  description: string;
  priority: TicketPriority;
  category: TicketCategory;
  loom_link?: string;
  project_id?: string;
  due_date?: string;
  contact_id?: string;
}

export interface UpdateTicketInput {
  title?: string;
  description?: string;
  status?: TicketStatus;
  priority?: TicketPriority;
  internal_priority?: TicketPriority;
  category?: TicketCategory;
  assigned_to?: string;
  project_id?: string;
  due_date?: string;
  loom_link?: string;
}

export interface CreateCommentInput {
  ticket_id: string;
  content: string;
  is_internal?: boolean;
  mentioned_user_ids?: string[];
}

export interface CreateAttachmentInput {
  ticket_id: string;
  file: File;
} 